import { Controller } from "@hotwired/stimulus"

// Disables the submit button until every required-consent checkbox is
// checked. The HTML5 `required` attribute already blocks form
// submission server-side; this controller just makes the UI clearer.
export default class extends Controller {
  static targets = ["required", "submit"]

  connect() {
    this.requiredTargets.forEach(el => {
      el.addEventListener("change", this.refresh.bind(this))
    })
    this.refresh()
  }

  refresh() {
    const allChecked = this.requiredTargets.every(el => el.checked)
    this.submitTarget.disabled = !allChecked
  }
}
